<template>
  <v-dialog
    v-model="dialogVisible"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    persistent
  >
    <v-card class="d-flex flex-column" style="height: 100vh; background-color: #f8fafc;">
      <!-- 1. Cabecera y Toolbar Principal -->
      <commercial-program-header
        :form-data="formData"
        :locked-budgets="lockedBudgets"
        :is-edit="isEdit"
        :is-view="isView"
        :saving="saving"
        :has-unsaved-changes="hasUnsavedChanges"
        @budget-selected="onBudgetSelected"
        @open-capacity-config="showCapacityConfigModal = true"
        @paste-excel="modalPasteExcel.show = true"
        @activate="onActivateProgramming"
        @close-prog="onCloseProgramming"
        @save="saveProgramming"
        @close="confirmClose"
        @mark-dirty="markDirty"
      />

      <!-- 2. Cards de Línea Base del Presupuesto Maestro (6 Cards) -->
      <commercial-budget-summary
        :budget-baseline="budgetBaseline"
        :form-data="formData"
      />

      <!-- 2.1 Card de Bolsa de Volumen Sin Cliente -->
      <div v-if="formData.EmbID && (budgetBaseline.NoClientTons > 0 || (computedUnassignedSummary && computedUnassignedSummary.AllocatedTons > 0))" class="px-3 pt-2 bg-white">
        <commercial-unassigned-budget-card
          :summary="computedUnassignedSummary"
          :is-view="isView"
          @open-assign="openAssignFromUnassigned"
          @view-history="openUnassignedHistory"
        />
      </div>

      <!-- 3. Pestañas de Navegación -->
      <v-tabs v-model="activeTab" background-color="white" color="primary" dense class="border-bottom flex-grow-0 px-3">
        <v-tab class="text-capitalize font-weight-bold">
          <v-icon left small>mdi-account-group-outline</v-icon>
          Desglose por Cliente
        </v-tab>
        <!-- <v-tab class="text-capitalize font-weight-bold">
          <v-icon left small>mdi-format-list-bulleted</v-icon>
          Ver Todas las Líneas ({{ activeLines.length }})
        </v-tab> -->
      </v-tabs>

      <!-- 4. Contenido Principal según Pestaña -->
      <div class="flex-grow-1 overflow-hidden d-flex flex-column" style="min-height: 0;">
        <!-- PESTAÑA 0: DESGLOSE POR CLIENTE (2 PANELES) -->
        <div v-show="activeTab === 0" class="d-flex flex-grow-1 overflow-hidden" style="height: 100%;">
          <!-- Panel Izquierdo: Lista Compacta de Clientes -->
          <commercial-client-list
            :customer-cards="customerCards"
            :selected-customer-id="selectedCustomerId"
            @select-customer="selectCustomer"
          />

          <!-- Panel Derecho: Líneas Comerciales del Cliente Seleccionado -->
          <commercial-client-detail
            :selected-customer="selectedCustomer"
            :client-lines="currentClientLines"
            :is-view="isView"
            @add-line="openAddLineModal"
            @add-similar="openAddSimilarLineModal"
            @edit-line="openEditLineModal"
            @duplicate-line="duplicateLine"
            @delete-line="removeLine"
          />
        </div>

      </div>

      <!-- 5. Consolidado Final de Programación Comercial (7 Cards) -->
      <!-- <commercial-program-summary
        :show-summary="Boolean(formData.EmbID)"
        :summary="programSummary"
        :budget-baseline="budgetBaseline"
        :active-lines-count="activeLines.length"
      /> -->

      <!-- 6. Modal / Drawer Lateral de Línea Comercial -->
      <commercial-line-modal
        v-model="modalLine.show"
        :is-edit="modalLine.isEdit"
        :is-similar="modalLine.isSimilar"
        :is-view="isView"
        :initial-data="modalLine.data"
        :selected-customer="selectedCustomer"
        :other-lines-for-client="otherLinesForCurrentClient"
        :division="formData.TypeDestination || 1"
        @save-line="onLineSaved"
      />

      <!-- 7. Modal de Importación Excel -->
      <commercial-programming-paste-excel-modal
        v-if="modalPasteExcel.show"
        v-model="modalPasteExcel.show"
        @import="onExcelLinesImported"
      />

      <!-- 8. Modal de Mantenimiento de Capacidades -->
      <commercial-capacity-config-modal
        v-if="showCapacityConfigModal"
        v-model="showCapacityConfigModal"
        :default-division="formData.TypeDestination || 1"
      />

      <!-- 9. Drawer de Trazabilidad de Asignaciones Sin Cliente -->
      <commercial-unassigned-allocation-history-drawer
        v-model="showUnassignedHistoryDrawer"
        :history-items="unassignedHistory"
        :loading="loadingUnassignedHistory"
        :is-view="isView"
        @revert-allocation="onRevertUnassignedAllocation"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CommercialProgrammingService from "@/services/ExternalTrade/CommercialProgrammingService";
import CommercialMasterBudgetService from "@/services/ExternalTrade/CommercialMasterBudgetService";
import CommercialProgrammingPasteExcelModal from "./CommercialProgrammingPasteExcelModal.vue";
import CommercialProgramHeader from "./components/CommercialProgramHeader.vue";
import CommercialBudgetSummary from "./components/CommercialBudgetSummary.vue";
import CommercialUnassignedBudgetCard from "./components/CommercialUnassignedBudgetCard.vue";
import CommercialUnassignedAllocationHistoryDrawer from "./components/CommercialUnassignedAllocationHistoryDrawer.vue";
import CommercialClientList from "./components/CommercialClientList.vue";
import CommercialClientDetail from "./components/CommercialClientDetail.vue";
import CommercialLineCard from "./components/CommercialLineCard.vue";
import CommercialLineModal from "./components/CommercialLineModal.vue";
import CommercialProgramSummary from "./components/CommercialProgramSummary.vue";
import CommercialCapacityConfigModal from "./components/CommercialCapacityConfigModal.vue";
import {
  computeCustomerCards,
  computeProgramSummary,
  recalculateLine,
  formatNumber,
} from "./utils/CommercialProgrammingCalculations";

export default {
  name: "CommercialProgrammingFormModal",
  components: {
    CommercialProgramHeader,
    CommercialBudgetSummary,
    CommercialUnassignedBudgetCard,
    CommercialUnassignedAllocationHistoryDrawer,
    CommercialClientList,
    CommercialClientDetail,
    CommercialLineCard,
    CommercialLineModal,
    CommercialProgramSummary,
    CommercialProgrammingPasteExcelModal,
    CommercialCapacityConfigModal,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    ecpId: {
      type: Number,
      default: 0,
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saving: false,
      hasUnsavedChanges: false,
      showCapacityConfigModal: false,
      activeTab: 0,
      lockedBudgets: [],
      budgetCustomers: [],
      selectedCustomerId: null,
      recentCustomerMemory: {},

      budgetBaseline: {
        TotalTons: 0,
        TotalFcl: 0,
        TotalFobUsd: 0,
        BudgetClients: 0,
        NoClientTons: 0,
      },

      unassignedSummary: {
        OriginalTons: 0,
        OriginalFcl: 0,
        OriginalFobUsd: 0,
        AllocatedTons: 0,
        AllocatedFcl: 0,
        AllocatedFobUsd: 0,
        AvailableTons: 0,
        AvailableFcl: 0,
        AvailableFobUsd: 0,
        AllocationPercentage: 0,
      },
      unassignedHistory: [],
      showUnassignedHistoryDrawer: false,
      loadingUnassignedHistory: false,

      formData: {
        EcpID: 0,
        EmbID: null,
        EmbVersion: 1,
        EmbName: "",
        CmpID: null,
        CmpName: "",
        TypeDestination: 1,
        TypeDestinationName: "Frescos",
        EcpName: "",
        EcpDate: new Date().toISOString().substr(0, 10),
        TypeCurrency: 2,
        EcpObservation: "",
        EcpStatus: 1,
        StatusName: "Borrador",
        SecStatus: 1,
        Details: [],
      },

      allLinesFilter: {
        search: "",
        incoterm: null,
        commType: null,
        destination: "",
      },

      modalLine: {
        show: false,
        isEdit: false,
        isSimilar: false,
        targetLineRef: null,
        data: {},
      },

      modalPasteExcel: {
        show: false,
      },
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
    isEdit() {
      return this.ecpId > 0 && !this.isView;
    },
    activeLines() {
      return (this.formData.Details || []).filter((d) => d.SecStatus === 1);
    },
    customerCards() {
      return computeCustomerCards(this.budgetCustomers, this.activeLines);
    },
    selectedCustomer() {
      if (!this.selectedCustomerId) return null;
      return this.customerCards.find(
        (c) => c.customerId === this.selectedCustomerId || c.customerName === this.selectedCustomerId
      );
    },
    currentClientLines() {
      if (!this.selectedCustomer) return [];
      const currentId = this.selectedCustomer.customerId;
      const currentName = this.selectedCustomer.customerName;

      return this.activeLines.filter((l) => {
        if (currentId) return l.PrsCustomerID === currentId;
        return (l.EpdCustomerName || "Sin Cliente") === currentName;
      });
    },
    otherLinesForCurrentClient() {
      const currentEditingId = this.modalLine.data._tempId;
      return this.currentClientLines.filter((l) => l._tempId !== currentEditingId);
    },
    programSummary() {
      return computeProgramSummary(this.budgetBaseline, this.activeLines);
    },
    filteredAllLines() {
      let list = this.activeLines;
      const f = this.allLinesFilter;

      if (f.search && f.search.trim()) {
        const t = f.search.trim().toLowerCase();
        list = list.filter(
          (l) =>
            (l.EpdCustomerName || "").toLowerCase().includes(t) ||
            (l.EpdProduct || "").toLowerCase().includes(t) ||
            (l.EpdBrand || "").toLowerCase().includes(t) ||
            (l.EpdPackaging || "").toLowerCase().includes(t)
        );
      }
      if (f.incoterm) list = list.filter((l) => l.TypeIncoterm === f.incoterm);
      if (f.commType) list = list.filter((l) => l.EpdCommercialType === f.commType);
      if (f.destination && f.destination.trim()) {
        const d = f.destination.trim().toLowerCase();
        list = list.filter((l) => (l.EpdPortDestination || "").toLowerCase().includes(d));
      }
      return list;
    },
    groupedLinesByCustomer() {
      const map = new Map();
      this.filteredAllLines.forEach((l) => {
        const key = l.PrsCustomerID || l.EpdCustomerName || "Sin Cliente";
        if (!map.has(key)) {
          const card = this.customerCards.find(
            (c) => (c.customerId && c.customerId === l.PrsCustomerID) || c.customerName === (l.EpdCustomerName || "Sin Cliente")
          );
          map.set(key, {
            customerKey: key,
            customerName: l.EpdCustomerName || "Sin Cliente",
            customerId: l.PrsCustomerID,
            budgetTons: card ? card.budgetTons : 0,
            availableBudgetTons: card ? card.availableBudgetTons : 0,
            otherProgrammedTons: card ? card.otherProgrammedTons : 0,
            programmedTons: 0,
            balanceTons: 0,
            programmedFobUsd: 0,
            lines: [],
          });
        }
        const group = map.get(key);
        group.lines.push(l);
        group.programmedTons += parseFloat(l.EpdProgrammedTons) || 0;
        group.programmedFobUsd += parseFloat(l.EpdAmountFobEquivalent) || 0;
        group.balanceTons = (group.availableBudgetTons || group.budgetTons) - group.programmedTons;
      });
      return Array.from(map.values());
    },
    computedUnassignedSummary() {
      const base = this.unassignedSummary || {
        OriginalTons: this.budgetBaseline.NoClientTons || 0,
        OriginalFcl: 0,
        OriginalFobUsd: 0,
        ReservedTons: 0,
        ReservedFcl: 0,
        ReservedFobUsd: 0,
        AllocatedTons: 0,
        AllocatedFcl: 0,
        AllocatedFobUsd: 0,
        AvailableTons: this.budgetBaseline.NoClientTons || 0,
        AvailableFcl: 0,
        AvailableFobUsd: 0,
        UsedPercentage: 0,
      };

      // Account for unsaved in-memory lines that come from unassigned budget
      const unsavedBagLines = this.activeLines.filter(
        (l) => (l.PrsCustomerOriginID === "Sin Cliente" || l.EpdCustomerOriginName === "Sin Cliente") && (!l.EpdID || l.EpdID === 0)
      );
      const localDraftTons = unsavedBagLines.reduce((acc, l) => acc + (parseFloat(l.EpdProgrammedTons) || 0), 0);
      const localDraftFcl = unsavedBagLines.reduce((acc, l) => acc + (parseFloat(l.EpdProgrammedFcl) || 0), 0);
      const localDraftFob = unsavedBagLines.reduce((acc, l) => acc + (parseFloat(l.EpdAmountFobEquivalent) || 0), 0);

      const origTons = base.OriginalTons || (this.budgetBaseline.NoClientTons || 0);
      const reservedTons = (base.ReservedTons || 0) + localDraftTons;
      const reservedFcl = (base.ReservedFcl || 0) + localDraftFcl;
      const reservedFob = (base.ReservedFobUsd || 0) + localDraftFob;
      const allocatedTons = base.AllocatedTons || 0;
      const allocatedFcl = base.AllocatedFcl || 0;
      const allocatedFob = base.AllocatedFobUsd || 0;

      const availableTons = Math.max(0, origTons - reservedTons - allocatedTons);
      const availableFcl = Math.max(0, (base.OriginalFcl || 0) - reservedFcl - allocatedFcl);
      const availableFob = Math.max(0, (base.OriginalFobUsd || 0) - reservedFob - allocatedFob);
      const usedTons = reservedTons + allocatedTons;
      const usedPercentage = origTons > 0 ? Math.min(100, (usedTons / origTons) * 100) : 0;

      return {
        ...base,
        OriginalTons: origTons,
        ReservedTons: reservedTons,
        ReservedFcl: reservedFcl,
        ReservedFobUsd: reservedFob,
        AllocatedTons: allocatedTons,
        AllocatedFcl: allocatedFcl,
        AllocatedFobUsd: allocatedFob,
        AvailableTons: availableTons,
        AvailableFcl: availableFcl,
        AvailableFobUsd: availableFob,
        UsedPercentage: usedPercentage,
        AllocationPercentage: usedPercentage,
      };
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) this.initModal();
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.value) {
      this.initModal();
    }
  },
  methods: {
    formatNumber,
    async initModal() {
      this.hasUnsavedChanges = false;
      this.activeTab = 0;
      this.selectedCustomerId = null;
      await this.loadLockedBudgets();
      if (this.ecpId > 0) {
        await this.loadProgramming();
      } else {
        this.resetForm();
      }
    },
    resetForm() {
      this.formData = {
        EcpID: 0,
        EmbID: null,
        EmbVersion: 1,
        EmbName: "",
        CmpID: null,
        CmpName: "",
        TypeDestination: 1,
        TypeDestinationName: "Frescos",
        EcpName: "",
        EcpDate: new Date().toISOString().substr(0, 10),
        TypeCurrency: 2,
        EcpObservation: "",
        EcpStatus: 1,
        StatusName: "Borrador",
        SecStatus: 1,
        Details: [],
      };
      this.budgetBaseline = { TotalTons: 0, TotalFcl: 0, TotalFobUsd: 0, BudgetClients: 0, NoClientTons: 0 };
      this.unassignedSummary = {
        OriginalTons: 0,
        OriginalFcl: 0,
        OriginalFobUsd: 0,
        AllocatedTons: 0,
        AllocatedFcl: 0,
        AllocatedFobUsd: 0,
        AvailableTons: 0,
        AvailableFcl: 0,
        AvailableFobUsd: 0,
        AllocationPercentage: 0,
      };
      this.unassignedHistory = [];
      this.budgetCustomers = [];
    },
    markDirty() {
      this.hasUnsavedChanges = true;
    },
    async loadLockedBudgets() {
      try {
        const res = await CommercialProgrammingService.getLockedBudgets({}, this.$fun.getUserID());
        if (res && res.data) {
          this.lockedBudgets = res.data.map((b) => {
            const display = `${b.EmbName} (v${b.EmbVersion}) - ${b.CmpName || ''} | ${b.TypeDestinationName || ''}`;
            return {
              ...b,
              text: display,
              value: b.EmbID,
              DisplayText: display,
              BudgetClients: b.TotalClients || b.BudgetClients || 0,
            };
          });
        }
      } catch (error) {
        console.error("Error al cargar presupuestos bloqueados:", error);
      }
    },
    async onBudgetSelected(embId) {
      if (!embId) {
        this.resetForm();
        return;
      }
      this.markDirty();
      const budget = this.lockedBudgets.find((b) => b.EmbID === embId);
      if (budget) {
        this.formData.EmbName = budget.EmbName;
        this.formData.EmbVersion = budget.EmbVersion;
        this.formData.CmpID = budget.CmpID;
        this.formData.CmpName = budget.CmpName;
        this.formData.TypeDestination = budget.TypeDestination;
        this.formData.TypeDestinationName = budget.TypeDestinationName;
        this.formData.TypeCurrency = budget.TypeCurrency || 2;
        if (!this.formData.EcpName) {
          this.formData.EcpName = `Programación ${budget.EmbName || 'Comercial'}`;
        }
        this.budgetBaseline = {
          TotalTons: budget.TotalTons || 0,
          TotalFcl: budget.TotalFcl || 0,
          TotalFobUsd: budget.TotalFobUsd || 0,
          BudgetClients: budget.TotalClients || budget.BudgetClients || 0,
          NoClientTons: budget.NoClientTons || 0,
        };
        await this.loadBudgetCustomers(embId);
        await this.loadUnassignedSummary(embId);
      }
    },
    async loadBudgetCustomers(embId) {
      try {
        const filter = {
          EmbID: embId,
          EcpID: this.formData.EcpID || 0,
        };
        const res = await CommercialProgrammingService.getBudgetCustomersAvailability(filter, this.$fun.getUserID());
        if (res && res.data) {
          this.budgetCustomers = res.data.map((bd) => ({
            PrsCustomerID: bd.PrsCustomerID,
            CustomerName: bd.CustomerName || "Sin Cliente",
            BudgetTons: bd.BudgetTons || 0,
            BudgetFcl: bd.BudgetFcl || 0,
            BudgetFobUsd: bd.BudgetFobUsd || 0,
            OtherProgrammedTons: bd.OtherProgrammedTons || 0,
            OtherProgrammedFcl: bd.OtherProgrammedFcl || 0,
            OtherProgrammedFobUsd: bd.OtherProgrammedFobUsd || 0,
            AvailableBudgetTons: bd.AvailableBudgetTons !== undefined ? bd.AvailableBudgetTons : ((bd.BudgetTons || 0) - (bd.OtherProgrammedTons || 0)),
            AvailableBudgetFcl: bd.AvailableBudgetFcl !== undefined ? bd.AvailableBudgetFcl : ((bd.BudgetFcl || 0) - (bd.OtherProgrammedFcl || 0)),
          }));
          if (this.budgetCustomers.length > 0 && !this.selectedCustomerId) {
            this.selectedCustomerId = this.budgetCustomers[0].PrsCustomerID || this.budgetCustomers[0].CustomerName;
          }
        }
      } catch (error) {
        console.error("Error al cargar clientes del presupuesto:", error);
      }
    },
    async loadUnassignedSummary(embId) {
      if (!embId) return;
      try {
        const res = await CommercialProgrammingService.getUnassignedAllocationSummary(
          embId,
          this.$fun.getUserID(),
          this.formData.EcpID || null
        );
        if (res && res.data) {
          this.unassignedSummary = res.data;
        }
      } catch (e) {
        console.error("Error al cargar resumen de volumen sin cliente:", e);
      }
    },
    async openUnassignedHistory() {
      if (!this.formData.EmbID) return;
      this.showUnassignedHistoryDrawer = true;
      this.loadingUnassignedHistory = true;
      try {
        const res = await CommercialProgrammingService.getUnassignedAllocationHistory(
          this.formData.EmbID,
          this.$fun.getUserID(),
          this.formData.EcpID || null
        );
        if (res && res.data) {
          this.unassignedHistory = res.data;
        }
      } catch (e) {
        console.error("Error al cargar historial de asignación:", e);
      } finally {
        this.loadingUnassignedHistory = false;
      }
    },
    openAssignFromUnassigned() {
      if (!this.computedUnassignedSummary || this.computedUnassignedSummary.AvailableTons <= 0) {
        this.$fun.alert("No hay volumen disponible en la bolsa sin cliente para asignar.", "warning");
        return;
      }
      this.modalLine = {
        show: true,
        isEdit: false,
        isSimilar: false,
        targetLineRef: null,
        data: {
          _tempId: Date.now(),
          EpdID: 0,
          EcpID: this.formData.EcpID || 0,
          EmdID: null,
          PrsCustomerOriginID: "Sin Cliente",
          EpdCustomerOriginName: "Sin Cliente",
          PrsCustomerID: null,
          EpdCustomerName: "",
          UsrExecutiveID: localStorage.getItem("UsrID") ? parseInt(localStorage.getItem("UsrID")) : (this.$fun ? this.$fun.getUserID() : null),
          EpdExecutive: (() => {
            const str = localStorage.getItem("UserInfo");
            if (str) {
              try {
                const u = JSON.parse(str);
                const parts = [u.NtpName, u.NtpPaternalSurname, u.NtpMaternalSurname].filter(Boolean);
                if (parts.length > 0) return parts.join(" ");
              } catch (e) {}
            }
            return localStorage.getItem("UsrFullName") || localStorage.getItem("UsrName") || "";
          })(),
          EpdProduct: "",
          EpdSapCode: "",
          EpdBrand: "",
          EpdPackaging: "",
          EpdCommercialType: 1,
          TypeIncoterm: 1,
          EpdPortDestination: "",
          PytID: null,
          EpdPaymentCondition: "",
          EpdEntryBase: 1,
          EpdCapacity: null,
          EpdProgrammedTons: 0,
          EpdProgrammedFcl: 0,
          EpdPriceAgreed: 0,
          EpdPriceFobEquivalent: 0,
          EpdPriceDifferential: 0,
          EpdAmountContract: 0,
          EpdAmountFobEquivalent: 0,
          EpdMarketPrice: null,
          EpdCommercialStatus: 1,
          EpdObservation: "Asignado desde bolsa de presupuesto sin cliente",
          SecStatus: 1,
        },
      };
    },
    async onRevertUnassignedAllocation(item) {
      const confirm = await this.$fun.alert(
        `¿Está seguro de revertir la asignación de ${item.EnaAllocatedTons} TM al cliente "${item.CustomerName || item.EnaCustomerName}" hacia la bolsa sin cliente?`,
        "question"
      );
      if (!confirm || !confirm.value) return;

      try {
        const res = await CommercialProgrammingService.cancelUnassignedAllocation({
          EnaID: item.EnaID,
          EpdID: item.EpdID,
          EnaReason: "Reversión manual por usuario",
        }, this.$fun.getUserID());
        if (res && res.data) {
          this.$fun.alert("Asignación revertida exitosamente.", "success");
          if (item.EpdID) {
            const line = (this.formData.Details || []).find(d => d.EpdID === item.EpdID);
            if (line) this.$set(line, "SecStatus", 0);
          }
          await this.loadUnassignedSummary(this.formData.EmbID);
          await this.openUnassignedHistory();
        }
      } catch (e) {
        const msg = (e.response && e.response.data) || e.message;
        this.$fun.alert(msg, "error");
      }
    },
    async loadProgramming() {
      try {
        const res = await CommercialProgrammingService.getById(this.ecpId, this.$fun.getUserID());
        if (res && res.data) {
          const data = res.data;
          this.formData = {
            ...data,
            EcpDate: data.EcpDate ? data.EcpDate.substr(0, 10) : new Date().toISOString().substr(0, 10),
            Details: (data.Details || []).map((d, i) => ({
              ...d,
              _tempId: Date.now() + i,
              selectedCustomer: d.PrsCustomerID ? { CardCode: d.PrsCustomerID, CardName: d.EpdCustomerName } : null,
            })),
          };
          this.budgetBaseline = {
            TotalTons: data.BudgetTons || 0,
            TotalFcl: data.BudgetFcl || 0,
            TotalFobUsd: data.BudgetFobUsd || 0,
            BudgetClients: data.BudgetClients || 0,
            NoClientTons: data.BudgetNoClientTons || 0,
          };
          if (data.EmbID) {
            await this.loadBudgetCustomers(data.EmbID);
            await this.loadUnassignedSummary(data.EmbID);
          }
        }
      } catch (error) {
        const msg = (error.response && error.response.data) || error.message;
        this.$fun.alert(msg, "error");
      }
    },
    selectCustomer(c) {
      this.selectedCustomerId = c.customerId || c.customerName;
    },
    openAddLineModal() {
      if (!this.selectedCustomer) {
        this.$fun.alert("Seleccione un cliente primero para agregar una línea.", "warning");
        return;
      }
      const client = this.selectedCustomer;
      const mem = this.recentCustomerMemory[client.customerId || client.customerName] || {};

      this.modalLine = {
        show: true,
        isEdit: false,
        isSimilar: false,
        targetLineRef: null,
        data: {
          _tempId: Date.now(),
          EpdID: 0,
          EcpID: this.formData.EcpID || 0,
          EmdID: null,
          PrsCustomerOriginID: client.customerId || null,
          EpdCustomerOriginName: client.customerName,
          PrsCustomerID: client.customerId || null,
          EpdCustomerName: client.customerName,
          UsrExecutiveID: localStorage.getItem("UsrID") ? parseInt(localStorage.getItem("UsrID")) : (this.$fun ? this.$fun.getUserID() : null),
          EpdExecutive: (() => {
            const str = localStorage.getItem("UserInfo");
            if (str) {
              try {
                const u = JSON.parse(str);
                const parts = [u.NtpName, u.NtpPaternalSurname, u.NtpMaternalSurname].filter(Boolean);
                if (parts.length > 0) return parts.join(" ");
              } catch (e) {}
            }
            return localStorage.getItem("UsrFullName") || localStorage.getItem("UsrName") || "";
          })(),
          EpdProduct: "",
          EpdSapCode: "",
          EpdBrand: mem.brand || "",
          EpdPackaging: mem.packaging || "",
          EpdCommercialType: mem.commType || 1,
          TypeIncoterm: mem.incoterm || 1,
          EpdPortDestination: mem.port || "",
          PytID: mem.pytId || null,
          EpdPaymentCondition: mem.payment || "",
          EpdEntryBase: mem.entryBase || 1,
          EpdCapacity: mem.capacity || null,
          EpdProgrammedTons: 0,
          EpdProgrammedFcl: 0,
          EpdPriceAgreed: mem.priceAgreed || 0,
          EpdPriceFobEquivalent: mem.priceFobEq || 0,
          EpdPriceDifferential: 0,
          EpdAmountContract: 0,
          EpdAmountFobEquivalent: 0,
          EpdMarketPrice: null,
          EpdCommercialStatus: 1,
          EpdObservation: "",
          SecStatus: 1,
        },
      };
    },
    openAddSimilarLineModal(baseLine) {
      if (!this.selectedCustomer) return;
      const target = baseLine || (this.currentClientLines.length > 0 ? this.currentClientLines[this.currentClientLines.length - 1] : null);
      if (!target) {
        this.openAddLineModal();
        return;
      }
      this.modalLine = {
        show: true,
        isEdit: false,
        isSimilar: true,
        targetLineRef: null,
        data: {
          ...JSON.parse(JSON.stringify(target)),
          _tempId: Date.now(),
          EpdID: 0,
          EpdProgrammedTons: 0,
          EpdProgrammedFcl: 0,
          EpdAmountContract: 0,
          EpdAmountFobEquivalent: 0,
          EpdObservation: "",
          SecStatus: 1,
        },
      };
    },
    openEditLineModal(line) {
      this.modalLine = {
        show: true,
        isEdit: true,
        isSimilar: false,
        targetLineRef: line,
        data: JSON.parse(JSON.stringify(line)),
      };
    },
    duplicateLine(line) {
      const duplicated = {
        ...JSON.parse(JSON.stringify(line)),
        _tempId: Date.now() + Math.random(),
        EpdID: 0,
        EpdProgrammedTons: 0,
        EpdProgrammedFcl: 0,
        EpdAmountContract: 0,
        EpdAmountFobEquivalent: 0,
        EpdObservation: "",
        SecStatus: 1,
      };
      this.modalLine = {
        show: true,
        isEdit: false,
        isSimilar: false,
        targetLineRef: null,
        data: duplicated,
      };
      this.$fun.alert("Línea duplicada. Ingrese el volumen correspondiente.", "info");
    },
    async removeLine(line) {
      const confirm = await this.$fun.alert("¿Está seguro de eliminar esta línea comercial?", "question");
      if (confirm && confirm.value) {
        if (line.EpdID > 0) {
          this.$set(line, "SecStatus", 0);
          if (line.PrsCustomerOriginID === "Sin Cliente" || line.EnaID > 0) {
            try {
              await CommercialProgrammingService.cancelUnassignedAllocation({
                EpdID: line.EpdID,
                EnaID: line.EnaID || 0,
                EnaReason: "Línea comercial eliminada",
              }, this.$fun.getUserID());
            } catch (e) {
              console.error("Error al cancelar asignación sin cliente:", e);
            }
          }
        } else {
          const idx = this.formData.Details.indexOf(line);
          if (idx !== -1) this.formData.Details.splice(idx, 1);
        }
        this.markDirty();
        if (this.formData.EmbID) {
          await this.loadUnassignedSummary(this.formData.EmbID);
        }
        this.$fun.alert("Línea eliminada.", "success");
      }
    },
    async onLineSaved({ data, keepAddingAnother, isEdit }) {
      this.markDirty();
      const memKey = data.PrsCustomerID || data.EpdCustomerName || "Sin Cliente";
      this.recentCustomerMemory[memKey] = {
        executive: data.EpdExecutive,
        incoterm: data.TypeIncoterm,
        port: data.EpdPortDestination,
        pytId: data.PytID,
        payment: data.EpdPaymentCondition,
        entryBase: data.EpdEntryBase,
        capacity: data.EpdCapacity,
        brand: data.EpdBrand,
        packaging: data.EpdPackaging,
        commType: data.EpdCommercialType,
        priceAgreed: data.EpdPriceAgreed,
        priceFobEq: data.EpdPriceFobEquivalent,
      };

      // Si el cliente es nuevo y no está en budgetCustomers, agregarlo con presupuesto 0
      if (data.PrsCustomerID || data.EpdCustomerName) {
        const exists = this.budgetCustomers.some(
          (c) => (c.PrsCustomerID && c.PrsCustomerID === data.PrsCustomerID) || c.CustomerName === data.EpdCustomerName
        );
        if (!exists) {
          this.budgetCustomers.push({
            PrsCustomerID: data.PrsCustomerID || null,
            CustomerName: data.EpdCustomerName || "Cliente No Presupuestado",
            BudgetTons: 0,
            BudgetFcl: 0,
            BudgetFobUsd: 0,
            OtherProgrammedTons: 0,
            OtherProgrammedFcl: 0,
            OtherProgrammedFobUsd: 0,
            AvailableBudgetTons: 0,
            AvailableBudgetFcl: 0,
          });
        }
        this.selectedCustomerId = data.PrsCustomerID || data.EpdCustomerName;
      }

      if (isEdit && this.modalLine.targetLineRef) {
        Object.assign(this.modalLine.targetLineRef, data);
        this.$fun.alert("Línea actualizada con éxito.", "success");
        this.modalLine.show = false;
      } else {
        if (!this.formData.Details) this.formData.Details = [];
        this.formData.Details.push({ ...data, _tempId: Date.now() + Math.random() });
        this.$fun.alert("Línea comercial agregada con éxito.", "success");
        if (keepAddingAnother) {
          this.openAddLineModal();
        } else {
          this.modalLine.show = false;
        }
      }

      if (this.formData.EmbID) {
        await this.loadUnassignedSummary(this.formData.EmbID);
      }
    },
    onExcelLinesImported(importedLines) {
      if (!importedLines || importedLines.length === 0) return;
      if (!this.formData.Details) this.formData.Details = [];

      importedLines.forEach((imp, idx) => {
        const line = {
          _tempId: Date.now() + idx,
          EpdID: 0,
          EcpID: this.formData.EcpID || 0,
          EmdID: null,
          PrsCustomerOriginID: imp.CustomerID || null,
          EpdCustomerOriginName: imp.CustomerName || "Sin Cliente",
          PrsCustomerID: imp.CustomerID || null,
          EpdCustomerName: imp.CustomerName || "Sin Cliente",
          selectedCustomer: imp.CustomerID ? { CardCode: imp.CustomerID, CardName: imp.CustomerName } : null,
          UsrExecutiveID: null,
          EpdExecutive: imp.Executive || "",
          EpdProduct: imp.Product || "MANGO",
          EpdSapCode: imp.SapCode || "",
          EpdBrand: imp.Brand || "",
          EpdPackaging: imp.Packaging || "",
          EpdCommercialType: imp.CommercialType || 1,
          TypeIncoterm: imp.Incoterm || 1,
          EpdPortDestination: imp.PortDestination || "",
          EpdPaymentCondition: imp.PaymentCondition || "",
          EpdEntryBase: imp.EntryBase || 1,
          EpdCapacity: imp.Capacity || null,
          EpdProgrammedTons: imp.ProgrammedTons || 0,
          EpdProgrammedFcl: imp.ProgrammedFcl || 0,
          EpdPriceAgreed: imp.PriceAgreed || 0,
          EpdPriceFobEquivalent: imp.PriceFobEquivalent || imp.PriceAgreed || 0,
          EpdPriceDifferential: 0,
          EpdAmountContract: 0,
          EpdAmountFobEquivalent: 0,
          EpdCommercialStatus: 1,
          EpdObservation: imp.Observation || "",
          SecStatus: 1,
        };
        recalculateLine(line);
        this.formData.Details.push(line);
      });
      this.markDirty();
      this.$fun.alert(`${importedLines.length} líneas importadas desde Excel con éxito.`, "success");
    },
    async saveProgramming() {
      if (!this.formData.EmbID) {
        this.$fun.alert("Debe seleccionar un Presupuesto Maestro Bloqueado.", "warning");
        return;
      }
      if (!this.formData.EcpName || !this.formData.EcpName.trim()) {
        this.$fun.alert("El nombre de la programación comercial es obligatorio.", "warning");
        return;
      }
      if (this.activeLines.length === 0) {
        this.$fun.alert("Debe registrar al menos una línea comercial válida.", "warning");
        return;
      }

      // Validar si algún cliente sobrepasa su presupuesto (Saldo negativo)
      const overBudgetClients = this.customerCards.filter((c) => c.balanceTons < -0.01);
      if (overBudgetClients.length > 0) {
        const clientNames = overBudgetClients.map((c) => c.customerName).join(", ");
        const confirmed = await this.$fun.alert(
          `Advertencia: Los siguientes clientes exceden el presupuesto asignado (${clientNames}). ¿Desea guardar la programación de todas formas?`,
          "question"
        );
        if (!confirmed || !confirmed.value) return;
      }

      try {
        this.saving = true;
        const res = await CommercialProgrammingService.save(this.formData, this.$fun.getUserID());
        if (res && res.data) {
          this.hasUnsavedChanges = false;
          this.$fun.alert("Programación comercial guardada exitosamente.", "success");
          this.$emit("saved");
          this.closeModal();
        }
      } catch (error) {
        const msg = (error.response && error.response.data) || error.message;
        this.$fun.alert(msg, "error");
      } finally {
        this.saving = false;
      }
    },
    async onActivateProgramming() {
      if (!this.formData.EcpID) return;
      const confirm = await this.$fun.alert(
        `¿Está seguro de activar la programación "${this.formData.EcpName}"?`,
        "question"
      );
      if (!confirm || !confirm.value) return;

      try {
        const res = await CommercialProgrammingService.activate(this.formData.EcpID, this.$fun.getUserID());
        if (res && res.data) {
          this.formData.EcpStatus = 2;
          this.formData.StatusName = "Activo";
          this.$fun.alert("Programación comercial activada exitosamente.", "success");
          if (this.formData.EmbID) {
            await this.loadUnassignedSummary(this.formData.EmbID);
            await this.loadBudgetCustomers(this.formData.EmbID);
          }
          this.$emit("saved");
        }
      } catch (e) {
        const msg = (e.response && e.response.data) || e.message;
        this.$fun.alert(msg, "error");
      }
    },
    async onCloseProgramming() {
      if (!this.formData.EcpID) return;
      const confirm = await this.$fun.alert(
        `¿Está seguro de cerrar la programación "${this.formData.EcpName}"? No se permitirán modificaciones adicionales.`,
        "question"
      );
      if (!confirm || !confirm.value) return;

      try {
        const res = await CommercialProgrammingService.close(this.formData.EcpID, this.$fun.getUserID());
        if (res && res.data) {
          this.formData.EcpStatus = 3;
          this.formData.StatusName = "Cerrado";
          this.$fun.alert("Programación comercial cerrada.", "success");
          this.$emit("saved");
        }
      } catch (e) {
        const msg = (e.response && e.response.data) || e.message;
        this.$fun.alert(msg, "error");
      }
    },
    confirmClose() {
      if (this.hasUnsavedChanges && !this.isView) {
        this.$fun.alert("Tiene cambios sin guardar en la programación. ¿Desea salir de todas formas?", "question").then((r) => {
          if (r && r.value) this.closeModal();
        });
      } else {
        this.closeModal();
      }
    },
    closeModal() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e2e8f0 !important;
}
.border-light {
  border: 1px solid #e2e8f0 !important;
}
.gap-2 {
  gap: 8px;
}
.gap-4 {
  gap: 16px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
